import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font,
  Image,
} from "@react-pdf/renderer";
import logo from "../../../Pages/Images/SMJ_Logo.png";
import instalogo from '../../../Pages/Images/insta_logo.png';
import { toWords } from "number-to-words";
import amazonLogo from "../../../Pages/Images/amazon.png";
import myntraLogo from "../../../Pages/Images/myntra.png";
import flipkartLogo from "../../../Pages/Images/flipkart.png";
import tickIcon from "../../../Pages/Images/tickicon.jpeg";
import diamondIcon from "../../../Pages/Images/diamond.png";
import sparkaleIcon from "../../../Pages/Images/Sparkle.png";
import giftIcon from "../../../Pages/Images/Gift.png";
import ringIcon from "../../../Pages/Images/Ring.jpeg";
import moneyIcon from "../../../Pages/Images/Money.jpg";
import voucherIcon from "../../../Pages/Images/Voucher.png";
import qrScanner from "../../../Pages/Images/QR1.png";

// Register fonts
Font.register({
  family: "Helvetica",
});

Font.register({
  family: "Helvetica-Bold",
  src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-bold-webfont.ttf",
});

// Styles
const styles = StyleSheet.create({
  page: {
    padding: 8,
    fontSize: 8,
    fontFamily: "Helvetica",
  },
  topRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 3,
  },
  smallBold: {
    fontSize: 8,
    fontFamily: "Helvetica-Bold",
  },
  logo: {
    width: 40,
    height: 40,
    marginHorizontal: 4,
  },
  title: {
    fontSize: 14,
    fontFamily: "Helvetica-Bold",
    textAlign: "center",
  },
  tagline: {
    fontSize: 9,
    fontStyle: "italic",
    textAlign: "center",
    marginTop: 4,
  },
  address: {
    fontSize: 8,
    marginTop: 5,
    textAlign: "center",
  },
  sup: {
    fontSize: 5,
    textBaseline: "alphabetic",
  },
  sectionRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 8,
    paddingHorizontal: 2,
  },
  sectionLeft: {
    width: "60%",
  },
  sectionRight: {
    width: "40%",
    textAlign: "right",
  },
  label: {
    fontSize: 9,
    fontFamily: "Helvetica-Bold",
  },
  value: {
    fontSize: 8,
    marginBottom: 1,
  },

  // Table styles
  table: {
    display: "table",
    width: "100%",
    borderWidth: 0.5,
    borderColor: "#000",
    marginTop: 6,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableColHeader: {
    flex: 1,
    backgroundColor: "#000",
    padding: 2,
    borderWidth: 0.5,
    borderColor: "#000",
  },
  tableCol: {
    flex: 1,
    borderWidth: 0.5,
    borderColor: "#000",
    padding: 2,
  },
  tableHeaderText: {
    fontSize: 8,
    color: "#fff",
    fontFamily: "Helvetica-Bold",
    textAlign: "center",
  },
  tableCell: {
    fontSize: 8,
    textAlign: "center",
  },

  // Summary section
  summaryRow: {
    flexDirection: "row",
    marginTop: 6,
  },
  summaryLeft: {
    flex: 1,
    borderWidth: 0.5,
    borderColor: "#000",
  },
  summaryRight: {
    flex: 1,
    borderWidth: 0.5,
    borderColor: "#000",
  },
  summaryHeader: {
    backgroundColor: "#000",
    flexDirection: "row",
  },
  summaryHeaderText: {
    flex: 1,
    color: "#fff",
    fontSize: 7,
    fontFamily: "Helvetica-Bold",
    textAlign: "center",
    padding: 2,
  },
  summaryRowItem: {
    flexDirection: "row",
    borderTopWidth: 0.5,
    borderColor: "#000",
  },
  summaryCell: {
    flex: 1,
    fontSize: 7,
    textAlign: "center",
    padding: 2,
  },

  // Amount + total section
  amountTotalRow: {
    flexDirection: "row",
    marginTop: 8,
    paddingHorizontal: 2,
  },
  amountSection: {
    flex: 1,
    paddingRight: 6,
  },
  amountInWords: {
    fontSize: 10,
    fontFamily: "Helvetica-Bold",
    marginBottom: 2,
  },
  amountInWordsText: {
    fontSize: 9,
    marginBottom: 2,
  },
  totalSection: {
    flex: 1,
    paddingLeft: 6,
  },
  totalRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 3,
  },
  totalLabel: {
    fontSize: 10,
    fontFamily: "Helvetica-Bold",
    width: "60%",
  },
  totalValue: {
    fontSize: 10,
    width: "40%",
    textAlign: "right",
  },

  noteSection: {
    marginTop: 6,
    marginBottom: 8,
  },
  noteHeading: {
    fontSize: 9,
    fontFamily: "Helvetica-Bold",
    marginBottom: 3,
  },
  noteText: {
    fontSize: 8,
    marginBottom: 2,
  },

  footer: {
    marginTop: 12,
    alignItems: "center",
  },
  thankYou: {
    fontSize: 11,
    fontFamily: "Helvetica-Bold",
    marginBottom: 4,
  },
  copyright: {
    fontSize: 8,
    marginTop: 6,
  },
  horizontalLine: {
    borderBottomWidth: 0.5,
    borderBottomColor: "#000",
    marginVertical: 4,
    width: "100%",
  },

  // Column width styles
  colSNo: {
    width: "15%",
    borderWidth: 0.5,
    borderColor: "#000",
    padding: 2,
    justifyContent: "center",
  },
  colMetal: {
    width: "25%",
    borderWidth: 0.5,
    borderColor: "#000",
    padding: 2,
    justifyContent: "center",
  },
  colParticulars: {
    width: "20%",
    borderWidth: 0.5,
    borderColor: "#000",
    padding: 2,
    justifyContent: "center",
  },
  colNtWt: {
    width: "20%",
    borderWidth: 0.5,
    borderColor: "#000",
    padding: 2,
    justifyContent: "center",
  },
  colHSN: {
    width: "20%",
    borderWidth: 0.5,
    borderColor: "#000",
    padding: 2,
    justifyContent: "center",
  },
});

// ✅ Styles for static promo page
const promoStyles = StyleSheet.create({
  page: { padding: 8, fontSize: 8, fontFamily: "Helvetica" },
  topRow: { flexDirection: "row", justifyContent: "space-between", alignItems: "center" },
  smallBold: { fontSize: 8, fontFamily: "Helvetica-Bold" },
  logo: { width: 30, height: 30, marginHorizontal: 4 },
  title: { fontSize: 14, fontFamily: "Helvetica-Bold", textAlign: "center" },
  tagline: { fontSize: 9, fontStyle: "italic", textAlign: "center", marginTop: 4 },
  address: { fontSize: 8, marginTop: 5, textAlign: "center" },
  sup: { fontSize: 5, textBaseline: "alphabetic" },

  // Promo specific styles
  promoContainer: { marginTop: 8 },
  mainTitle: { fontSize: 12, fontFamily: "Helvetica-Bold", textAlign: "center", marginRight: 6 },
  subtitle: { fontSize: 9, textAlign: "center", marginBottom: 10, lineHeight: 1.3 },

  // Investment sections
  investmentSection: { marginBottom: 10 },
  investmentTitle: { fontSize: 12, fontFamily: "Helvetica-Bold", marginBottom: 4 },
  investmentSubtitle: { fontSize: 9, fontStyle: 'italic', marginBottom: 6 },
  featureItem: { flexDirection: 'row', alignItems: 'flex-start', marginBottom: 3 },
  checkbox: { width: 8, height: 8, borderWidth: 0.5, borderColor: '#000', marginRight: 4, marginTop: 1 },
  checkedCheckbox: { width: 8, height: 8, borderWidth: 0.5, borderColor: '#000', marginRight: 4, marginTop: 1, backgroundColor: '#000' },
  featureText: { fontSize: 9, lineHeight: 1.2, flex: 1 },

  // Footer
  footer: { marginTop: 8, alignItems: "center" },
  thankYou: { fontSize: 11, fontFamily: "Helvetica-Bold", marginBottom: 4 },
  copyright: { fontSize: 8, marginTop: 6 },
  separator: { borderTopWidth: 0.5, borderTopColor: '#000', marginVertical: 6 },
  instaRow: { flexDirection: "row", alignItems: "center", justifyContent: "center", marginTop: 4 },
  instaLogo: { width: 10, height: 10, marginRight: 3 },
  instaText: { fontSize: 8 },
});

const InvoiceDocument = ({ formData }) => {
  const currentTime = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // Convert amount to words
  const amountInWords = toWords(parseFloat(formData?.discount_amt || 0)).replace(/(^\w|\s\w)/g, (m) => m.toUpperCase());

  return (
    <Document>
      <Page size={[300, 500]} style={styles.page}>
        {/* Top Row: GSTIN | Logo | Contact */}
        <View style={styles.topRow}>
          <Text style={styles.smallBold}>GSTIN: 29ADOPG5916E1ZE</Text>
          <Image src={logo} style={styles.logo} />
          <View>
            <Text style={styles.smallBold}>Contact: 916 916 9680</Text>
            <Text style={[styles.smallBold, { marginLeft: 33 }]}>080 26719107</Text>
          </View>
        </View>

        {/* Title + tagline + address */}
        <Text style={styles.title}>Sri Mahaganapathi Jewellers</Text>
        <Text style={[styles.tagline, { marginLeft: 50 }]}>
          Our Craft For Your Precious Stories
        </Text>
        <Text style={styles.address}>
          No 606, 14<Text style={styles.sup}>th</Text> Main Road, Siddanna Layout,
          BSK 2<Text style={styles.sup}>nd</Text> Stage
        </Text>

        {/* Customer Details + Invoice Info */}
        <View style={styles.sectionRow}>
          <View style={styles.sectionLeft}>
            <Text style={styles.label}>Customer Details:</Text>
            <Text style={styles.value}>Name: {formData?.account_name || "N/A"}</Text>
            <Text style={styles.value}>Mobile: {formData?.mobile || "N/A"}</Text>
          </View>
          <View style={styles.sectionRight}>
            <Text style={styles.value}>Invoice No: {formData?.receipt_no || "N/A"}</Text>
            <Text style={styles.value}>Date: {formatDate(formData?.date)}</Text>
            <Text style={styles.value}>Time: {currentTime}</Text>
          </View>
        </View>

        {/* Items Table */}
        <View style={styles.table}>
          {/* Header */}
          <View style={styles.tableRow}>
            <View style={[styles.colSNo, { backgroundColor: "#000" }]}><Text style={styles.tableHeaderText}>S.No</Text></View>
            <View style={[styles.colMetal, { backgroundColor: "#000" }]}><Text style={styles.tableHeaderText}>Invoice No.</Text></View>
            <View style={[styles.colParticulars, { backgroundColor: "#000" }]}><Text style={styles.tableHeaderText}>Total Amount</Text></View>
            <View style={[styles.colNtWt, { backgroundColor: "#000" }]}><Text style={styles.tableHeaderText}>Paid Amount</Text></View>
            <View style={[styles.colHSN, { backgroundColor: "#000" }]}><Text style={styles.tableHeaderText}>Balance Amount</Text></View>
          </View>
          <View style={styles.tableRow}>
            <View style={styles.colSNo}><Text style={styles.tableCell}>1</Text></View>
            <View style={styles.colMetal}><Text style={styles.tableCell}>{formData?.invoice_number || "N/A"}</Text></View>
            <View style={styles.colParticulars}><Text style={styles.tableCell}>{formData?.total_amt || "0.00"}</Text></View>
            <View style={styles.colNtWt}><Text style={styles.tableCell}>{formData?.discount_amt || "0.00"}</Text></View>
            <View style={styles.colHSN}><Text style={styles.tableCell}>{formData?.cash_amt || "0.00"}</Text></View>
          </View>
          <View style={styles.tableRow}>
            <View style={[styles.colSNo]}><Text style={styles.tableCell}></Text></View>
            <View style={[styles.colMetal]}><Text style={styles.tableCell}></Text></View>
            <View style={styles.colParticulars}><Text style={styles.tableCell}>{formData?.total_amt || "0.00"}</Text></View>
            <View style={styles.colNtWt}><Text style={styles.tableCell}>{formData?.discount_amt || "0.00"}</Text></View>
            <View style={styles.colHSN}><Text style={styles.tableCell}>{formData?.cash_amt || "0.00"}</Text></View>
          </View>
        </View>
        {/* Footer */}
        <View style={styles.footer}>
          <Text style={styles.thankYou}>Thank You | Visit Again</Text>

          {/* Left & Right Side */}
          <View style={{ flexDirection: "row", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              <Image
                src={instalogo}
                style={{ width: 12, height: 12, marginRight: 1, marginTop: 5 }}
              />
              <Text style={styles.copyright}>jewellers_srimahaganapathi</Text>
            </View>
            <Text style={styles.copyright}>SMJ Authorized Sign</Text>
          </View>
        </View>
      </Page>

     
    </Document>
  );
};

export default InvoiceDocument;